module.exports = __webpack_public_path__ + "img/apply_yes.5e3c473f.png";